module.exports = __webpack_public_path__ + "img/icon_manual_sale.44f76403.png";